<template>
  <v-row>
    <v-col
      cols="11"
      sm="5"
      class="py-0"
    >
      <v-menu
        ref="menu_from"
        v-model="time_menu_from"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="hours.from"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="hours.from"
            :label="$t('orders.open_from')"
            prepend-icon="access_time"
            readonly
            v-on="on"
            hide-details
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="time_menu_from"
          v-model="hours.from"
          format="24hr"
          color="kazan"
          header-color="#212121"
          full-width
          @click:minute="$refs.menu_from.save(hours.from)"
        ></v-time-picker>
      </v-menu>
    </v-col>
    <v-col class="hidden-xs-only"
      align-self="center"
      sm="1"
      
      style="text-align: center"
    >
      -
    </v-col>
    <v-col
      cols="11"
      sm="5"
      class="py-0"
    >
      <v-menu
        ref="menu_to"
        v-model="time_menu_to"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="hours.to"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="hours.to"
            :label="$t('orders.open_to')"
            prepend-icon="access_time"
            readonly
            v-on="on"
            hide-details
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="time_menu_to"
          v-model="hours.to"
          format="24hr"
          color="kazan"
          header-color="#212121"
          full-width
          @click:minute="$refs.menu_to.save(hours.to)"
        ></v-time-picker>
      </v-menu>
    </v-col>
    <v-col
      align-self="center"
      sm="1"
      style="text-align: center"
    >
      <v-btn text icon color="kazan" @click="removeRange()" class="ma-0">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LocationFormOpeningsRange',
  props: {
    day: String,
    index: String,
    value: Object
  },
  data () {
    return {
      time_menu_from: false,
      time_menu_to: false,
      hours: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    hours: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    removeRange: function () {
      this.$emit('remove-range', this.day, this.index)
    }
  }
}
</script>
